import {Component} from 'react';
import "./GameViews/flipTopCard.css";
import "./GameViews/gameViews.css";

class GameCardFaceDown extends Component {
    constructor(props) {
        super(props);
        this.animationComplete = this.animationComplete.bind(this);
        this.state = {
        }
        this.lastCard = false;
    }

    animationComplete(){
        this.props.stopFlipCard();
    }

    render() {
        let firstRight = 50;
        let offset = 15;
        if (this.props.screenSize === "narrow"){
             firstRight = 60;
             offset = 10;
        }
        let rightNbr = firstRight - (offset * parseInt(this.props.index));
        let bottomNbr = 120 - (offset * parseInt(this.props.index));
        let cardCount = this.props.index + 1;
        if (cardCount === this.props.nbrCards && this.props.cardDisabled === false){
            this.lastCard = true;
            let positionObj = {right: rightNbr, bottom: bottomNbr};
            this.props.lastCard(positionObj);
        }
        let right = +rightNbr + "px";
        let bottom = bottomNbr + "px";
        let topCard = false;
        if (cardCount === this.props.nbrCards){
            topCard = true;
        }
        let cardClass = "";
        if (topCard === true){
            cardClass = "facedown-game-card game-card-blue";
            if (this.props.flipCard === true){
                cardClass += " flip-top-card";
            }
        }else{
            cardClass = "facedown-game-card game-card-blue";
        }
                     
    return <>
        
        <div className={cardClass} style={{right: right, bottom: bottom}} 
            disabled={this.props.cardDisabled} onClick={() => this.props.onClick()}
            onAnimationEnd={this.animationComplete}>
        
            <div className="d-flex align-items-center h-100">
                <img src="./assets/sidebar_icon.png" className="w-100" alt="gameCard"/>
            </div>
        </div>
 {/*      <div className="faceup-game-card game-card-green">Testing card placement</div> */}
    </>
    }
       
}

export default GameCardFaceDown;    